import React from 'react';
import PropTypes from 'prop-types';
import { Headline3 } from '@cdm/quickenloans-library/lib'
import Link from '../Link';
import { testAttributes, compProps } from './Constants';
import * as CSS from './FooterMenu.module.scss';

const FooterMenu = ({ menuItems = compProps }) => (menuItems?.map((column) => (
    <div
        data-testid={`${testAttributes.MENU_CONTAINER}${column.databaseId}`}
        className={`${CSS.menuContainer} qld-s-cfull qld-m-cfull qld-g12-c4`}
        key={column.databaseId}
    >
        <Headline3
            data-testid={`${testAttributes.MENU_HEADING}${column.databaseId}`}
            className={CSS.headline6}
        >
            {column.label}
        </Headline3>
        <ul
            data-testid={`${testAttributes.MENU_LIST}${column.databaseId}`}
            className={CSS.menuList}
            itemScope
            itemType="http://www.schema.org/SiteNavigationElement"
        >
            {column?.submenu?.nodes.map((item) => (
                <li
                    data-testid={`${testAttributes.MENU_ITEM}${item.databaseId}`}
                    className={CSS.menuItem}
                    key={item.databaseId}
                    itemProp="name"
                >
                    <Link
                        itemProp="url"
                        href={item.path}
                    >
                        <span itemProp="name">{item.label}</span>
                    </Link>
                </li>
            ))}
        </ul>
    </div>
)));

FooterMenu.propTypes = {
    /** Footer menu columns with links */
    menuItems: PropTypes.array,
};

export default FooterMenu;
